import { render } from "./CheckboxSimpleInput.vue?vue&type=template&id=2432a3b6"
import script from "./CheckboxSimpleInput.vue?vue&type=script&lang=js"
export * from "./CheckboxSimpleInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__